import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { BenefitSummary } from '../../models/benefits.model';
import {
	deleteOrgBenefitStart,
	deleteStepClear,
	fetchOrgBenefitsClear,
	fetchOrgBenefitsStart,
} from '../../state/organizations.actions';
import {
	selectBenefits,
	selectDeleteStep,
	selectOrgLoading,
} from '../../state/organizations.selector';

@Component({
	selector: 'app-del-benefit-dialog',
	template: `
		<app-dialog
			modalTitle="Atenção"
			titleButton="Sim"
			secTitleButton="Não"
			[secButton]="true"
			[asAlert]="true"
			(dialogClose)="dialogRef.close(false)"
			(dialogSave)="dialogRef.close(true)"
		>
			<p class="lh-md">
				A exclusão desse benefício pode afetar alguns beneficiários que possuem
				este benefício. Tem certeza que deseja continuar?
			</p>
		</app-dialog>
	`,
})
export class DelBenefitDialogComponent {
	constructor(public dialogRef: MatDialogRef<DelBenefitDialogComponent>) {}
}

@Component({
	selector: 'app-benefits',
	styleUrls: ['./benefits.component.scss'],
	templateUrl: './benefits.component.html',
})
export class BenefitsComponent implements OnInit, OnDestroy {
	alertRef!: MatDialogRef<DelBenefitDialogComponent>;
	benefits: BenefitSummary[] = [];
	benefitsTabs = [
		{ label: 'Saúde', path: 'saude' },
		{ label: 'Dental', path: 'dental' },
	];
	filteredBenefits: BenefitSummary[] = [];

	health_plans: boolean = true;
	loading: boolean = true;
	loading$: Observable<boolean>;

	private paramsId: string = '';

	private readonly unsubscribe$: Subject<void> = new Subject();

	constructor(
		private readonly router: Router,
		private readonly activatedRoute: ActivatedRoute,
		private readonly dialog: MatDialog,
		private readonly store: Store,
	) {
		this.loading$ = this.store.select(selectOrgLoading);
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
		this.store.dispatch(fetchOrgBenefitsClear());
	}

	ngOnInit(): void {
		this.activatedRoute.params.subscribe(({ id }) => {
			if (id) {
				this.paramsId = id;
				this.store.dispatch(fetchOrgBenefitsStart({ id: this.paramsId }));
				this.store
					.select(selectBenefits)
					.pipe(takeUntil(this.unsubscribe$))
					.subscribe((benefits) => {
						if (benefits) {
							this.benefits = benefits;
							this.onTabClick('saude');
							this.loading = false;
						}
					});
			}
		});
	}

	onDeletePlan(id: string): void {
		this.alertRef = this.dialog.open(DelBenefitDialogComponent, {
			disableClose: true,
			maxWidth: undefined,
		});
		this.alertRef.afterClosed().subscribe((result) => {
			if (result) {
				this.store
					.select(selectDeleteStep)
					.pipe(takeUntil(this.unsubscribe$))
					.subscribe((step) => {
						if (step === 1) {
							this.store.dispatch(deleteStepClear());
							this.store.dispatch(fetchOrgBenefitsStart({ id: this.paramsId }));
						}
					});
				this.store.dispatch(
					deleteOrgBenefitStart({ id, orgId: this.paramsId }),
				);
			}
		});
	}

	onEditPlan(id: string): void {
		if (this.paramsId) {
			this.router.navigateByUrl(
				`organizacoes/${this.paramsId}/beneficios/${id}`,
			);
		}
	}

	onTabClick(path: string): void {
		if (path === 'saude') {
			this.filteredBenefits = this.benefits.filter((b) => b.health_benefit);
			this.health_plans = true;
		} else {
			this.filteredBenefits = this.benefits.filter((b) => b.dental_benefit);
			this.health_plans = false;
		}
	}
}
